"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentryHandler = void 0;
const Sentry = __importStar(require("@sentry/nextjs"));
let exceptionsBeforeInit = [];
const errorLevel = 'error';
const fatalLevel = 'fatal';
const sentryHandler = (error, options) => {
    const sendEvent = ({ client_time, error, options }) => {
        var _a, _b;
        Sentry.setTag('client_time', client_time);
        if ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b['x-request-id']) {
            Sentry.setTag('request_id', error.response.headers['x-request-id']);
        }
        if (options) {
            Sentry.withScope(scope => {
                var _a, _b;
                let status = error === null || error === void 0 ? void 0 : error.status;
                if (error.isAxiosError) {
                    status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
                }
                if ((_b = options.tag) === null || _b === void 0 ? void 0 : _b.includes('interceptor')) {
                    scope.setLevel(fatalLevel);
                }
                scope.setLevel(errorLevel);
                if (options.tag) {
                    scope.setTag('functional', options.tag);
                }
                if (status) {
                    scope.setTag('status', status);
                }
                if (error === null || error === void 0 ? void 0 : error.id) {
                    scope.setTag('errorId', error === null || error === void 0 ? void 0 : error.id);
                }
                if (options.extra) {
                    scope.setExtra('extra', JSON.stringify(options.extra));
                }
                Sentry.captureException(error);
            });
        }
        else {
            Sentry.captureException(error);
        }
    };
    if (!Sentry.getClient()) {
        exceptionsBeforeInit.push({ error, options, client_time: new Date().toLocaleString() });
    }
    else {
        exceptionsBeforeInit.push({ error, options, client_time: new Date().toLocaleString() });
        exceptionsBeforeInit.forEach(exception => {
            sendEvent(exception);
        });
        exceptionsBeforeInit = [];
    }
};
exports.sentryHandler = sentryHandler;
